import { render, staticRenderFns } from "./GenerateFerryPayment.vue?vue&type=template&id=2758567c"
import script from "../../../controllers/custom/student_statement/generate-ferry-payment.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/student_statement/generate-ferry-payment.js?vue&type=script&lang=js&external"
import style0 from "./GenerateFerryPayment.vue?vue&type=style&index=0&id=2758567c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports